import { Injectable } from '@angular/core';
declare let THREE: any;
import { OnInit } from '@angular/core';
import { SceneUtilsService } from '../../services/scene-utils.service';
import { ComponentBase } from '../../component-base';
import { StageService } from '../../services/stage.service';
import { HelperLinesService } from '../../services/helper-lines.service';
import { GeometryHelperService } from '../../services/geometry-helper.service';
import { Line } from '../../custom/line';
import { TextureUtilsService } from '../../services/texture-utils.service';
import { ImageUtilsService } from '../../services/image-utils.service';
import { UnitsManagerService } from '../../services/units-manager.service';
import { RoomStateManagerService } from '../../services/room-state-manager.service';
import { ProjectManagerService } from '../../services/project-manager.service';
import { BuildFloorService } from '../../services/build-floor.service';
import {ZoomService} from '../../services/zoom.service';
import {SceneryService} from '../../services/scenery.service';

@Injectable()
export class DrawCustomRoomService extends ComponentBase implements OnInit {

    constructor(
        private sceneUtils: SceneUtilsService,
        private stage: StageService,
        private zoomCamera: ZoomService,
        private helperLines: HelperLinesService,
        private geometryHelper: GeometryHelperService,
        private textureUtils: TextureUtilsService,
        private imageUtils: ImageUtilsService,
        private unitsManager: UnitsManagerService,
        private roomStateManager: RoomStateManagerService,
        private projectSrvc: ProjectManagerService,
        private buildFloorService: BuildFloorService,
        private env: SceneryService
    ) {
        super();
        this.roomCloseTrigger.radius = 10;
    }
    screenshot: any;
    getAngle(angleRad) {
        var angleDeg = Math.abs(THREE.Math.radToDeg(angleRad));
        if ((angleDeg >= 177 && angleDeg <= 183))
            return THREE.Math.degToRad(180);
        else if (angleDeg <= 2)
            return 0;
        else if (angleDeg >= 87 && angleDeg <= 93)
            return THREE.Math.degToRad(90) * Math.sign(angleRad);
        else
            return angleRad;
    }

    private fistClick: any;
    private roomCloseTrigger = new THREE.Sphere();
    private roomCloseRay = new THREE.Ray(new THREE.Vector3(0, 0, 0), new THREE.Vector3(0, -1, 0));

    private lastPoint: any;
    private points = [];
    private currentWallLine: any;

    public isScratch: boolean = false;

    mouseDown(e) {
        if (!this.isScratch) { return };
        this.lastPoint = this.currentWallLine
            ? this.currentWallLine.getEndPoint()
            : this.sceneUtils.screenToWorld(e.offsetX, e.offsetY);

        this.lastPoint.y = 0;



        if (!this.fistClick) {
            this.fistClick = true;
            this.roomCloseTrigger.center.copy(this.lastPoint);
            this.stage.addMany(this.helperLines.getLines());
        }
        if (this.currentWallLine) {
            var length = this.currentWallLine.position.distanceTo(this.lastPoint);
        }
        if (!this.currentWallLine || length > 25) {
            this.stage.addMany(this.helperLines.getLines());

            this.points.push(this.lastPoint);
            this.currentWallLine = new Line(this.textureUtils, this.imageUtils, this.unitsManager);
            this.currentWallLine.position.copy(this.lastPoint);
            this.stage.add(this.currentWallLine);
        }

        return false;
    }

    private drawWall(e) {
        if (this.lastPoint) {

            var pos = this.sceneUtils.screenToWorld(e.offsetX, e.offsetY).setY(0),
                diff = pos.clone().sub(this.lastPoint),
                newLength = diff.length(),
                angle = this.getAngle(-Math.atan2(diff.z, diff.x)),
                pointIntersection = this.helperLines.test(pos, this.points),
                delta;

            if (pointIntersection) {
                delta = pointIntersection.sub(this.lastPoint);
                angle = -Math.atan2(delta.z, delta.x);
                newLength = delta.length();
            }

            this.currentWallLine.rotation.y = angle;
            this.currentWallLine.updateLength(newLength);

            this.roomCloseRay.origin.copy(pos);
            if (this.points.length >= 3 && this.roomCloseRay.intersectSphere(this.roomCloseTrigger)) {
                this.closeCustomRoom();
            }
        }
    }

    mouseMove(e) {

        if (!this.isScratch) { return };
        if (this.points.length == 1 && this.lastPoint.x - e.offsetX <= 10) {
            this.env.change('grid');
            this.currentWallLine = new Line(this.textureUtils, this.imageUtils, this.unitsManager);
            this.currentWallLine.position.copy(this.lastPoint);
            this.stage.add(this.currentWallLine);
        }

        this.drawWall(e);

        var canvasPosition = this.stage.getCanvas().getBoundingClientRect();

        if (e.x + 10 >= canvasPosition.right || e.x - 10 <= canvasPosition.left
            || e.y + 10 >= canvasPosition.bottom || e.y - 10 <= canvasPosition.top) {
            this.zoomCamera.out(e);
            this.drawWall({ offsetX: e.offsetX, offsetY: e.offsetY, x: e.x, y: e.y });
        }
        return false;
    }

    keydown(e) {
        if (e.keyCode === 27) {
            this.closeCustomRoom();
        }
    }

    private closeCustomRoom() {

        var m = new THREE.Matrix4();
        m.makeRotationX(Math.PI / 2);
        var ps = this.points.map(function (p) {
            var a = p.clone();
            a.applyMatrix4(m);
            return a;
        });

        var isClockwise = this.geometryHelper.isClockwisePolygon(ps);

        if (!isClockwise)
            this.points.reverse();

        this.env.change('grid');

        var points = this.points.map(function (p) {
            return {
                x: p.x,
                y: p.z
            }
        });
        this.roomStateManager.setPoints(points);
        // this.projectSrvc.setPoints(points);
        // this.fireEvent('created', points);

        this.buildFloorService.buildFloor({ points, height: undefined, mainFloor: true });
        this.disable();
    }

    disable() {
        ComponentBase.prototype.disable.call(this);
        this.points.length = 0;
        this.fistClick = false;
        this.currentWallLine = this.lastPoint = null;
    }

    ngOnInit() {
        // ComponentBase.prototype.constructor.call(this);
        this.fistClick = false;

        // this.roomCloseTrigger = new THREE.Sphere();
        this.roomCloseTrigger.radius = 10;
        // this.roomCloseRay = new THREE.Ray(new THREE.Vector3(0, 0, 0),
        //     new THREE.Vector3(0, -1, 0));

        this.lastPoint = null;
        this.points = [];
    }

}



// WEBPACK FOOTER //
// ./src/app/Component(2D and 3D)/2D/draw-custom-room.service.ts